import callApi from './callApi';

export const sendQuery = async (data) => {
  const url = `notifications/send-query-email`;
  const headers = {
    
  };
  const body = {
    data
  }
  return await callApi(url, headers, 'POST', body);
}